import { render, staticRenderFns } from "./FlipClock.vue?vue&type=template&id=5ba211cd&"
import script from "./FlipClock.vue?vue&type=script&lang=js&"
export * from "./FlipClock.vue?vue&type=script&lang=js&"
import style0 from "./FlipClock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba211cd')) {
      api.createRecord('5ba211cd', component.options)
    } else {
      api.reload('5ba211cd', component.options)
    }
    module.hot.accept("./FlipClock.vue?vue&type=template&id=5ba211cd&", function () {
      api.rerender('5ba211cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/FlipClock.vue"
export default component.exports